import React, { useState, useEffect } from "react";
import api from "../constant/api"; // உங்களுடைய API Path

export default function AICommandManager() {
  const [commands, setCommands] = useState([]);
  const [route, setRoute] = useState("");
  const [keywords, setKeywords] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  // 1. டேட்டாவை லோடு செய்ய (Fetch Commands)
  const fetchCommands = async () => {
    try {
      const res = await api.get("/ai/getAIKeywordsRaw"); // கமாண்டுகளின் லிஸ்ட் எடுக்கும் ஏபிஐ
      if (res.data && res.data.success) {
        setCommands(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching commands:", error);
    }
  };

  useEffect(() => {
    fetchCommands();
  }, []);

  // 2. Insert அல்லது Edit டேட்டாவைச் சேமிக்க (Submit Form)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!route || !keywords) return alert("Please fill all fields!");

    setLoading(true);
    try {
      if (editId) {
        // Edit / Update API Call
        await api.put(`/ai/updateCommand/${editId}`, { route, keywords });
        alert("கீவேர்ட் வெற்றிகரமாக மாற்றப்பட்டது!");
      } else {
        // Insert / Create API Call
        await api.post("/ai/addCommand", { route, keywords });
        alert("புதிய கீவேர்ட் வெற்றிகரமாக சேர்க்கப்பட்டது!");
      }

      // படிவத்தை பழையபடி மாற்ற (Reset Form)
      setRoute("");
      setKeywords("");
      setEditId(null);
      fetchCommands(); // டேபிளை புதுப்பிக்க
    } catch (error) {
      console.error("Error saving command:", error);
      alert("ஏதோ தவறு நடந்துள்ளது!");
    } finally {
      setLoading(false);
    }
  };

  // 3. எடிட் மோடுக்கு மாற்ற (Set Fields for Editing)
  const handleEdit = (cmd) => {
    setEditId(cmd.id);
    setRoute(cmd.route);
    setKeywords(cmd.keywords); // Comma separated string-ஆகவே காட்டும்
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>AI Voice Command Manager (நிர்வாகப் பக்கம்)</h2>

      {/* 🌟 Insert / Edit Form */}
      <form onSubmit={handleSubmit} style={{ marginBottom: "30px", background: "#f5f5f5", padding: "20px", borderRadius: "8px" }}>
        <h3>{editId ? "Edit Command (மாற்றியமைக்க)" : "Add New Command (புதிதாக சேர்க்க)"}</h3>
        
        <div style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>Route Path (எந்தப் பக்கம் செல்ல வேண்டும்):</label>
          <input
            type="text"
            placeholder="e.g., /PurchaseOrder"
            value={route}
            onChange={(e) => setRoute(e.target.value)}
            disabled={editId ? true : false} // எடிட் செய்யும் போது ரூட்டை மாற்றாமல் இருப்பது பாதுகாப்பானது
            style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>Keywords (வாய்ஸ் கமாண்டுகள் - கமாவால் பிரிக்கவும்):</label>
          <input
            type="text"
            placeholder="e.g., purchase, கொள்முதல், po, ஆர்டர்"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
            style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
          />
          <small style={{ color: "#666" }}>*வார்த்தைகளை கமா (,) குறியீட்டுடன் உள்ளிடவும்.</small>
        </div>

        <button type="submit" disabled={loading} style={{ background: "#4CAF50", color: "white", padding: "10px 15px", border: "none", borderRadius: "4px", cursor: "pointer" }}>
          {loading ? "Saving..." : editId ? "Update Command" : "Save Command"}
        </button>
        
        {editId && (
          <button type="button" onClick={() => { setEditId(null); setRoute(""); setKeywords(""); }} style={{ marginLeft: "10px", background: "#aaa", color: "white", padding: "10px 15px", border: "none", borderRadius: "4px", cursor: "pointer" }}>
            Cancel
          </button>
        )}
      </form>

      {/* 🌟 Commands Table (தற்போது இருக்கும் கமாண்டுகளின் பட்டியல்) */}
      <h3>Current Voice Commands List</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
        <thead>
          <tr style={{ background: "#ddd", textAlign: "left" }}>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>Route / Page</th>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>Keywords / Voice Commands</th>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {commands.map((cmd) => (
            <tr key={cmd.id}>
              <td style={{ padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>{cmd.route}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{cmd.keywords}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                <button onClick={() => handleEdit(cmd)} style={{ background: "#2196F3", color: "white", padding: "5px 10px", border: "none", borderRadius: "4px", cursor: "pointer" }}>
                  Edit
                </button>
              </td>
            </tr>
          ))}
          {commands.length === 0 && (
            <tr>
              <td colSpan="3" style={{ padding: "20px", textAlign: "center", color: "#999" }}>No data found. விபரங்கள் எதுவும் இல்லை.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}